/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

import { Autocomplete, Button, Typography } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { DividerHr } from '@components/common/Divider/Divider';

import { colors } from '../../../../theme';


interface IRoamingOptionContainerTextStyled {
	minHeight?: number;
	marginBottom?: number;
	marginTop?: number;
}

interface IRoamingOptionTypography {
	isdashedunderline?: boolean;
}

interface IRoamingOptionCard {
	isSelected?: boolean;
}

export const DividerHrStyled = styled(DividerHr)`
	width: 100%;
	margin-top: 20px;
	margin-bottom: 20px;
`;

export const FootnoteTypographyStyled = styled(Typography)`
	.MuiTypography-root > span > p {
		margin-bottom: 16px;
	}
`;

export const LinkContainer = styled.div`
	margin-top: 20px;
`;

export const RoamingOptionCardInfoStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	gap: 6px;
`;

export const RoamingOptionCardBottom = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const RoamingOptionTypographyStyled = styled(Typography)<IRoamingOptionTypography>`
	cursor: ${({ isdashedunderline }) => (isdashedunderline ? 'pointer' : 'default')};
	border-bottom: ${({ isdashedunderline }) => (isdashedunderline ? '1px dashed' : 'none')};
`;

export const RoamingOptionCallsButtonStyled = styled(Button)`
	&.MuiButtonBase-root {
		padding: 0;
	}
`;

export const RoamingOptionIntenetButtonStyled = styled(Button)`
	&.MuiButtonBase-root {
		padding: 0;
		border-radius: 8px;
		min-width: 48px;
		box-shadow: 0 0.25px 3px rgba(0, 0, 0, 0.15);
	}
`;

export const RoamingOptionCardServiceDescriptionStyled = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
`;

export const RoamingOptionCardServiceInfoStyled = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const RoamingOptionContainerTextStyled = styled.div<IRoamingOptionContainerTextStyled>`
	height: ${({ minHeight }) => (minHeight ? minHeight + 'px' : 'auto')};
	margin-top: ${({ marginTop }) => marginTop + 'px'};
	margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom + 'px' : 0)};

	& .MuiTypography-root {
		margin-bottom: 0;
	}
`;

export const RoamingOptionCardStyled = styled.li.attrs(({ isSelected }: IRoamingOptionCard) => ({
    className: `roaming-option-card-item ${isSelected ? 'selected' : ''}`,
}))<IRoamingOptionCard>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;

	padding: 20px 12px 16px 16px;
	margin: 0 16px 16px 0;

	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
	border: 1px solid ${colors.tariffsAndServicesCardBorderColorNormal};
	background: ${colors.tariffsAndServicesCardBgColor};

	cursor: pointer;

    &:hover {
        border: 1px solid ${colors.tariffsAndServicesCardBorderColorHover};
    }

    &.selected {
        outline: 2px solid ${colors.tariffsAndServicesCardBorderColorSelected};
        box-shadow: 0 2px 8px rgba(0, 185, 86, 0.16);
    }

	height: 550px;
	width: 285px;

	border-radius: 4px;
`;

export const AutocompleteControl = styled(Autocomplete)`
	width: 100%;

	& > .MuiFormControl-root {
		padding-right: var(--padding-xs);
		padding-bottom: 0;

		${props => props.theme.breakpoints.down('sm')} {
			width: 100%;
			max-width: 400px;
		}

		& > .MuiAutocomplete-inputRoot {
			height: 50px;
			border: var(--card-border);
		}
	}
`;

export const RoamingControlsStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 887px;

	padding: 20px 12px 16px 16px;
	margin-bottom: 20px;
	margin-top: 10px;

	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
	border-radius: 8px;

	gap: 10px;
`;

export const RoamingSearchContainerStyled = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
`;
